import swal from "sweetalert"
import UserService from "./../API/UserService"
import { getRefreshToken, removeUserSession } from "../Variables/Common"

const userService = new UserService()


 export const CatchError = async (error, navigation, refreshtoken) => {
  const response =  error.response
  if (!response) {
    swal("Error", `Unxepected Error\n\n ${error.message}`,"warning" )
  } else {
    if (response.status === 401 && refreshtoken) {
        // alert(`${response.status} ${response.statusText}`)
        try {
          await userService.refreshUser(refreshtoken)
        } catch (error) {
          removeUserSession()
          navigation('/')
        }
    } else if (response.status === 401 && !refreshtoken) {
        removeUserSession()
        navigation('/')
    } else if(response.status === 403){
      navigation('/403')
    } else if(response.status === 500){
      navigation('/500')
    } else if(response.status === 400 || response.status === 404 || response.status === 422){
      swal(`${response.status} ${response.statusText}`, `${response.data.message}`,"warning" )
    } else {
      swal("Error", `Unxepected Error\n\n ${error.message}`,"warning" )
  }
  }
}

 export const CatchErrorDashboard = async (error, navigation) => {
  const refreshtoken = getRefreshToken()
  const response =  error.response
  if (!response) {
    swal("Error", `Unxepected Error\n\n ${error.message}`,"warning" )
  } else {
    if (response.status === 401 && refreshtoken) {
        // alert(`${response.status} ${response.statusText}`)
        try {
          await userService.refreshUser(refreshtoken)
        } catch (error) {
          // console.log(error.message)
          removeUserSession()
          navigation('/')
        }
    } else if (response.status === 401 && !refreshtoken) {
        removeUserSession()
        navigation('/')
    } else if(response.status === 403){
      removeUserSession()
      navigation(`/`)
    } else if(response.status === 500){
      navigation('/500')
    } else if(response.status === 400 || response.status === 404 || response.status === 422){
      swal(`${response.status} ${response.statusText}`, `${response.data.message}`,"warning" )
    } else {
      swal("Error", `Unxepected Error\n\n ${error.message}`,"warning" )
  }
  }
}

export const CatchLoginError = (error, navigation, isNav = false) => {
  const navigate = typeof navigation === 'function' ? navigation : (path) => {
    window.location.href = path
  }
  const response =  error.response
  if (!response) {
    swal("Error", `Server Offline \n\n ${error.message}`,"warning" )
    if (!isNav) {
      return
    }
    return navigate(`/`)
  } else {
    if (!response.status) {
    swal("Error", `Unxepected Error\n\n ${error.message}`,"warning" )
    if (!isNav) {
      return
    }
    return navigate(`/`)
    } else {
      swal(`${response.status} ${response.statusText}`, `${response.data.message}`,"warning" )
      if (!isNav) {
        return
      }

      return navigate(`/`)
    }
  }
}
